/**
 * Zet een ingevoerd telefoonnummer om naar de href van een belknop.
 *
 * Nummers worden met de hand ingevoerd, dus met spaties, streepjes en haakjes.
 * Een telefoon kiest alleen als de href die tekens niet bevat, dus blijven
 * alleen de cijfers over — plus een landcode vooraan.
 *
 * Levert een lege string op zodra er niets te bellen valt, zodat de aanroeper
 * op de waarde kan beslissen of hij de belknop überhaupt toont. Let op: de
 * weergave-terugval '—' bevat geen cijfers en valt hier dus vanzelf weg.
 *
 * @param {string} [phone] - Het nummer zoals de gebruiker het invoerde
 * @returns {string} `tel:<nummer>`, of '' wanneer er geen nummer in staat
 */
const telHref = (phone) => {
    const raw = typeof phone === 'string' ? phone.trim() : ''
    if (!raw) return ''

    const digits = raw.replace(/[^0-9]/g, '')
    if (!digits) return ''

    // Alleen een plus vooraan is een landcode; midden in het nummer is het een
    // typefout, en die zou de href onbruikbaar maken.
    const prefix = raw.startsWith('+') ? '+' : ''

    return `tel:${prefix}${digits}`
}

export default telHref
